import { theme as themeConfig } from "UI/theme"
import styled from "styled-components"

export const Paragraphs = styled.div`
  color: ${themeConfig.palette.text.primary};
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.01em;
  line-height: 1.9em;
  margin-bottom: 30px;

  p {
    color: ${themeConfig.palette.text.primary};
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    letter-spacing: 0.01em;
    line-height: 1.9em;

    @media (max-width: 768px) {
        padding-right: 20px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.91px;
        line-height: 27px;
    }
  }
`

export const ExcerptParagraphs = styled.div`
  color: ${themeConfig.palette.text.primary};
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0.01em;
  line-height: 1.5em;
  margin-bottom: 50px;

  p {
    color: ${themeConfig.palette.text.primary};
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: 0.01em;
    line-height: 1.5em;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 27px;
    }
  }
`
